import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon, FlameIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, PRODUCT_IMAGE } from '../data/hero';
export function Hero() {
  return <header className="relative overflow-hidden bg-obsidian text-white" data-id="element-113" data-mp="9lbkfd8rfxje">
      <div className="mx-auto grid max-w-6xl gap-y-7 px-5 pb-14 pt-8 text-center lg:grid-cols-[1fr_1.1fr] lg:gap-x-12 lg:gap-y-8 lg:pb-20 lg:pt-16 lg:text-left" style={{
      paddingTop: "0px",
      paddingBottom: "10px",
      gap: "13px"
    }} data-id="element-114" data-mp="4mrsmw7hjrj4">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-115" data-mp="x8joxsyd72kd">
          
          <h1 className="mt-4 font-display text-[46px] font-extrabold uppercase leading-[0.92] tracking-tight sm:text-6xl lg:text-[76px]" style={{
          fontSize: "36px"
        }} data-id="element-116" data-mp="s9giq56neqat">
            Daha Akıllı Antrenman Yap.
            <br data-id="element-117" data-mp="382fgbrjt9agi" />
            Daha İyi Beslen.
            <br data-id="element-118" data-mp="381nv9anuav4h" />
            <span className="text-electric" data-id="element-119" data-mp="3814aznapvuna">Yarışa Güvenle Hazırlan.</span>
          </h1>
          <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-white/70 sm:text-lg lg:mx-0" data-id="element-120" data-mp="3j925dog4jqvj">
            Antrenmandan bitiş çizgisine kadar tüm hazırlık sürecinizi tek bir sistem içinde organize edin.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-121" data-mp="3e9fpt8ctpyjk">
          <img src={PRODUCT_IMAGE} alt="UZUN MESAFE TRİATLON SİSTEMİ™ ve dört bonus rehberi tabletlerde" width={1536} height={1024} fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[620px] drop-shadow-[0_30px_40px_rgba(20,125,255,0.18)]" data-id="element-122" data-mp="2qk3m2o09mion" />
        </motion.div>

        <div className="lg:col-start-1 lg:row-start-2" data-id="element-123" data-mp="2lla5untlgdks">
          
          <p className="mt-1 text-sm font-semibold text-white/85" data-id="element-124" data-mp="2lml9mnn1hlbw">6 aşamalı kapsamlı hazırlık sistemi + 4 ücretsiz bonus.</p>
          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-white/60 lg:justify-start" data-id="element-125" data-mp="nbl3ooe6ymc1">
            <span className="flex items-center gap-1" data-id="element-126" data-mp="id9tgcjzi9ta">
              <span className="flex text-ember" aria-label="5 üzerinden 4,9 yıldız" data-id="element-127" data-mp="dd5dqoqwhj44">
                {Array.from({
                length: 5
              }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-128" data-mp="1b0dsm0webtx5" data-mpi={k} />)}
              </span>
              <span className="font-semibold text-white" data-id="element-129" data-mp="162lyd08a3vps">4,9</span>
            </span>
            <span data-id="element-130" data-mp="111507ch6incw">500’den fazla elit ve amatör sporcu</span>
            <span className="inline-flex items-center gap-1" data-id="element-131" data-mp="x1nwanhehy9u">
              <ZapIcon className="h-3.5 w-3.5 text-aqua" aria-hidden="true" data-id="element-132" data-mp="x37ewkqj4les" /> Anında erişim
            </span>
          </p>

          <div className="mt-6 flex justify-center lg:justify-start" data-id="element-133" data-mp="3hrlmgnykwhbm">
            <CTAButton href="#pricing" data-id="element-134" data-mp="3htgaib55cpjx">Sistemin tamamını inceleyin</CTAButton>
          </div>

          <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-135" data-mp="1x783jjm4pjs0">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/[0.04] px-3 py-1.5 text-xs font-medium text-white/80" data-id="element-136" data-mp="268y69llgo553">
                <Icon className="h-3.5 w-3.5 text-aqua" aria-hidden="true" data-id="element-137" data-mp="2g02hqbbxh7v6" />
                {label}
              </li>)}
          </ul>

          

          <div className="mt-5 flex flex-col items-center gap-2 lg:items-start" data-id="element-138" data-mp="2kxc7js38bljj">
            <p className="inline-flex items-center gap-1.5 rounded-full border border-ember/35 bg-ember/10 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-ember" data-id="element-139" data-mp="2p1jvhn1v4xgp">
              <FlameIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-140" data-mp="un98lk4twddk" />
              Sınırlı süreli teklif · Lansman sonrasında fiyat tekrar yükselecek
            </p>
            <p className="flex items-center gap-1.5 text-xs text-white/45" data-id="element-141" data-mp="4bdwtfu749om">
              <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-142" data-mp="4dgw6qh8nf60" />
              Şu anda 11 kişi bu ürünü inceliyor
            </p>
          </div>
        </div>
      </div>
    </header>;
}